import {createContext, useContext } from "react";
import UiStore from "./store/UiStore";

export const UIStoreContext = createContext(UiStore)